import { render } from "./View.vue?vue&type=template&id=5a7f4e3e&bindings={\"file\":\"setup\",\"state\":\"setup\",\"languages\":\"setup\",\"updateFile\":\"setup\",\"formatDate\":\"setup\",\"updateFileName\":\"setup\"}"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
script.render = render

export default script